import { Action } from '@ngrx/store';
import { Department } from '../department/department.model';

export enum DepartmentWsActionTypes {
  LocalCreateDepartmentSuccessWs = '[Department WS] Local Create Departments Success',
  LocalCreateDepartmentFailureWs = '[Department WS] Local Create Departments Failure',
  LocalUpdateDepartmentSuccessWs = '[Department WS] Local Update Departments Success',
  LocalUpdateDepartmentFailureWs = '[Department WS] Local Update Departments Failure',
  LocalRemoveDepartmentSuccessWs = '[Department WS] Local Remove Departments Success',
  LocalRemoveDepartmentFailureWs = '[Department WS] Local Remove Departments Failure',
  GlobalCreateDepartmentSuccessWs = '[Department WS] Global Create Departments Success',
  GlobalUpdateDepartmentSuccessWs = '[Department WS] Global Update Departments Success',
  GlobalRemoveDepartmentSuccessWs = '[Department WS] Global Remove Departments Success',
}

export class LocalCreateDepartmentSuccessWs implements Action {
  readonly type = DepartmentWsActionTypes.LocalCreateDepartmentSuccessWs;
  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalCreateDepartmentFailureWs implements Action {
  readonly type = DepartmentWsActionTypes.LocalCreateDepartmentFailureWs;
  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalUpdateDepartmentSuccessWs implements Action {
  readonly type = DepartmentWsActionTypes.LocalUpdateDepartmentSuccessWs;
  constructor(public payload: { id: string; correlation_id: string }) {}
}

export class LocalUpdateDepartmentFailureWs implements Action {
  readonly type = DepartmentWsActionTypes.LocalUpdateDepartmentFailureWs;
  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class LocalRemoveDepartmentSuccessWs implements Action {
  readonly type = DepartmentWsActionTypes.LocalRemoveDepartmentSuccessWs;
  constructor(public payload: { correlation_id: string }) {}
}

export class LocalRemoveDepartmentFailureWs implements Action {
  readonly type = DepartmentWsActionTypes.LocalRemoveDepartmentFailureWs;
  constructor(public payload: { correlation_id: string; message: string }) {}
}

export class GlobalCreateDepartmentSuccessWs implements Action {
  readonly type = DepartmentWsActionTypes.GlobalCreateDepartmentSuccessWs;
}

export class GlobalUpdateDepartmentSuccessWs implements Action {
  readonly type = DepartmentWsActionTypes.GlobalUpdateDepartmentSuccessWs;
}

export class GlobalRemoveDepartmentSuccessWs implements Action {
  readonly type = DepartmentWsActionTypes.GlobalRemoveDepartmentSuccessWs;

  constructor(public payload: { id: Department['id'] }) {}
}

export type DepartmentWsActions =
  | LocalCreateDepartmentSuccessWs
  | LocalCreateDepartmentFailureWs
  | LocalUpdateDepartmentSuccessWs
  | LocalUpdateDepartmentFailureWs
  | LocalRemoveDepartmentSuccessWs
  | LocalRemoveDepartmentFailureWs
  | GlobalCreateDepartmentSuccessWs
  | GlobalUpdateDepartmentSuccessWs
  | GlobalRemoveDepartmentSuccessWs;
